'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var calendarDate_styles = require('./calendar-date.styles-9072cd1e.js');

var CalendarDate = function (_a) {
    var number = _a.number, variant = _a.variant, handlePress = _a.onPress, _b = _a.size, size = _b === void 0 ? 'lg' : _b, divProps = tslib_es6.__rest(_a, ["number", "variant", "onPress", "size"]);
    var handleClick = React.useCallback(function (event) {
        // eslint-disable-next-line no-unused-expressions
        handlePress === null || handlePress === void 0 ? void 0 : handlePress(number, event);
    }, [number, handlePress]);
    return (React__default.createElement(calendarDate_styles.CalendarDateStyled, tslib_es6.__assign({ variant: variant, onClick: handleClick, role: "button", size: size }, divProps), number));
};

exports.CalendarDate = CalendarDate;
